<div class="row">
  @if (label !== undefined) {
    <div [ngClass]="{'col-md-6 text':!sidebar, 'text-sidebar': sidebar, 'smaller-heading':smallerHeading}"
         class="col-12 dealer-label">
      <strong>{{ label }}</strong>
    </div>
  }
  <div [ngClass]="{'col-md-6': !sidebar, 'bid-for-other-dealer': offerId}" class="col-12 dealer-input">
    <input (blur)="blur()"
           (input)="onInput()"
           (focus)="onFocus()"
           (typeaheadOnSelect)="onSelect($event)"
           [(ngModel)]="selectedValue"
           [placeholder]="placeholder"
           [typeaheadItemTemplate]="customItemTemplate"
           [typeaheadMinLength]="0"
           [typeaheadOptionsLimit]="7"
           [typeaheadScrollable]="showBiddingDealers"
           [typeahead]="typeaheadData$"
           class="form-control search-field {{ class }}"
           typeaheadOptionField="name">
    <ng-template #customItemTemplate let-dealer="item">
        @if (showBiddingDealers && offerId && bidDataSource?.length > 0) {
            <b>{{ dealer.companyNumber + ' ' +dealer.name}}</b>
            <div class="bidding-dealer">{{ dealer.firstName + ' ' +dealer.lastName}}</div>
        } @else {
            {{ dealerService.getCompanyNumberOrPbvCustomerNumber(dealer, channel) + ' ' + dealer.name }}
        }
    </ng-template>
  </div>

</div>
